import React, { createContext, useContext, useState, useMemo } from "react";
import { dict } from "@/i18n/content";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("rosas_lang") || "es";
  });

  const value = useMemo(() => {
    const setL = (l) => {
      setLang(l);
      try {
        localStorage.setItem("rosas_lang", l);
      } catch (e) {
        // ignore storage errors
      }
    };
    return { lang, t: dict[lang], setLang: setL, toggle: () => setL(lang === "es" ? "en" : "es") };
  }, [lang]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
